import { useState } from 'react';
import { FroalaTextareaView } from '@/components/Froala/FroalaTextareaView';
import { useTranslation } from 'react-i18next';
import { encode } from '@/base64';
import { decodeHtml } from '@/util';

export const TabbedContentBoxView = ({
  state,
  index,
  onModified = undefined,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(
    state?.contentBoxes?.length ? state?.contentBoxes[0] : null
  );

  return (
    <div
      className={`flex flex-col  rounded-lg bg-[#f8f8f9] p-4`}
      style={{ maxWidth: 'calc(100vw - 32px)' }}
      data-state={encode(JSON.stringify(state))}
    >
      <FroalaTextareaView value={state.title} className="mb-4" />

      <div className=" flex flex-col">
        <div className="my-2 flex flex-wrap items-center gap-2">
          {state?.contentBoxes?.map((tab) => {
            return (
              <div
                key={tab?.uid}
                className={`cursor-pointer rounded-lg px-3 py-[6px] text-base font-medium text-[#231F20] ${
                  tab?.uid == activeTab?.uid
                    ? 'bg-grey-02 text-[#231F20]'
                    : 'text-grey-07'
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {decodeHtml(tab?.title)}
              </div>
            );
          })}
        </div>
        <div>
          <FroalaTextareaView value={activeTab?.text} />
        </div>
      </div>
    </div>
  );
};
